module.exports = "<p>automation works!</p>\n"